import React, {useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles, useTheme, fade } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from "@material-ui/core/CircularProgress";
import { Button } from '@material-ui/core';

import Avatar from '@material-ui/core/Avatar';
import SetCli from './SetCli';
import SetRenew from './SetRenew';
import RenewCharge from './RenewCharge';
import CancelDID from './CancelDID';

import Switch from '@material-ui/core/Switch';

import InputBase from '@material-ui/core/InputBase';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

import { green, amber, red } from '@material-ui/core/colors';


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function EnhancedTableHead(props) {
  const { headCells, classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={'center'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    minHeight: "48px"
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
  search: {
    backgroundColor: "aliceblue",
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'black',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
}));


const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected, handleSearch, searchval } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
    <Typography className={classes.title} color="inherit" variant="subtitle1">
    </Typography>
      <React.Fragment>
        <div className={classes.search}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Search …"
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          id="id_search"
          value={searchval}
          inputProps={{ 'aria-label': 'search' }}
          onChange={handleSearch}
        />
      </div>
        </React.Fragment>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired
};

const useStyles1 = makeStyles(() => ({
    root: {
      flexShrink: 0,
      margin: 0,
    },
  }));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = event => {
      onChangePage(event, 0);
    };

    const handleBackButtonClick = event => {
      onChangePage(event, page - 1);
    };

    const handleNextButtonClick = event => {
      onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
      onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.root}>
        <IconButton
          style={{paddingRight: '0px'}}
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="pierwsza">
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          style={{paddingRight: '0px'}}
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page">
          {theme.direction === 'rtl' ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          style={{paddingRight: '0px'}}
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="następna">
          {theme.direction === 'rtl' ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          style={{paddingRight: '0px'}}
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="ostatnia">
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: "100%",
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  green: {
    color: '#fff',
    backgroundColor: green[500],
    width: '70px',
    height: '20px',
    fontSize: '14px'
  },
  amber: {
    color: '#fff',
    backgroundColor: amber[500],
    width: '70px',
    height: '20px',
    fontSize: '14px'
  },
  red: {
    color: '#fff',
    backgroundColor: red[500],
    width: '70px',
    height: '20px',
    fontSize: '14px'
  },
}));


function DIDsTable(props) {
    const { rows, headCells, loading, handleRefresh } = props;
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState({});
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [search, setSearch] = React.useState([]);
  const [searchval, setSearchval] = React.useState({search: ""});

  const [newSetCli, setCliOpen] = React.useState(false);
  const [newCancelDID, setCancelDIDOpen] = React.useState(false);
  const [newAutoRenew, setAutoRenewOpen] = React.useState(false);
  const [newRenewCharge, setRenewChargeOpen] = React.useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    event.persist();
   setSearchval(searchval => ({...searchval, search: event.target.value}));
  };

  useEffect(() => {
    if (selected.length !== 0) {
      const ret = rows.filter(r => r.id === selected[0]);
      setSelectedRow(ret[0]);
    } else {
      setSelectedRow([]);
    }
  if (searchval.search === "") {
      setSearch(rows);
  } else {
      let rest = [];
      rows.forEach(function(row){
        return Object.keys(row).some(function(key){
            if(row[key] !== null){
              if (row[key].toString().toLowerCase().includes(searchval.search.toLowerCase())) {
                return rest.push(row);
              }
            }
            return false;
          })
      })
      if(rest.length === 0 ){
        setSearch([]);
      } else {
        setSearch(rest);
      }
  }
  }, [rows, selected, searchval]);

  const isSelected = id => selected.indexOf(id) !== -1;

  const handleSetCliClose = async () => {
    setCliOpen(false);
    await handleRefresh();
  };

  const handleCancelDIDClose = async () => {
    setCancelDIDOpen(false);
    await handleRefresh();
  };

  const handleRenewClose = async () => {
    setAutoRenewOpen(false);
    await handleRefresh();
  };

  const handleRenewChargeClose = async () => {
    setRenewChargeOpen(false);
    await handleRefresh();
  };

  return (
    <div className={classes.root}>
      <CancelDID
          open={newCancelDID}
          handleClose={handleCancelDIDClose}
          rowselected={selectedRow}
        />
        <SetCli
          open={newSetCli}
          handleClose={handleSetCliClose}
          rowselected={selectedRow}
        />
        <SetRenew
          open={newAutoRenew}
          handleClose={handleRenewClose}
          rowselected={selectedRow}
        />
         <RenewCharge
          open={newRenewCharge}
          handleClose={handleRenewChargeClose}
          rowselected={selectedRow}
        />
        <EnhancedTableToolbar
            selectedRow={selectedRow}
            numSelected={selected.length}
            handleSearch={handleSearch}
            searchval={searchval.search}
        />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={'small'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              headCells={headCells}
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
            {search.length !== 0 && !loading ? (
                stableSort( search, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.did);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.did}
                      selected={isItemSelected}
                    >
                      <TableCell align="left">{row.card_nr}</TableCell>
                      <TableCell align="left" id={labelId} scope="row"><b>{row.did}</b></TableCell>
                      <TableCell align="left"> {row.status === 'active' ? (
                            <Avatar variant="rounded" className={classes.green}>
                              {row.status}
                            </Avatar>
                          ) : row.status === 'declined' ||  row.status === 'expired' ?
                          (
                            <Avatar variant="rounded" className={classes.red}>
                              {row.status}
                            </Avatar>
                          )
                          : (
                            <Avatar variant="rounded" className={classes.amber}>
                              {row.status}
                            </Avatar>
                          )
                        }</TableCell>
                       <TableCell align="left">{ row.start_date !== '' ? (
                            <Switch
                              checked={row.auto_renew}
                              onChange={() => {
                                setAutoRenewOpen(row.status !== 'expired' ? true : false);
                                setRenewChargeOpen(row.status === 'expired' ? true : false);
                                setSelectedRow(row);
                              }}
                              color="primary"
                              name="enabled"
                              inputProps={{ 'aria-label': 'checkbox enabled' }}
                            />) : null
                      }
                      </TableCell>
                      <TableCell align="left">
                        { row.status === 'active' ?
                           ( <Switch
                              checked={row.CLI}
                              onChange={() => {
                                setCliOpen(row.CLI ? false : true);
                                setSelectedRow(row);
                              }}
                              color="primary"
                              name="enabled"
                              inputProps={{ 'aria-label': 'checkbox enabled' }}
                            /> ) : null
                        }
                      </TableCell>
                      <TableCell align="left">{row.months}</TableCell>
                      <TableCell align="left"><b>{row.cost}</b></TableCell>
                      <TableCell align="left">{row.country}</TableCell>
                      <TableCell align="left">{row.area}</TableCell>
                      <TableCell align="left">{row.start_date}</TableCell>
                      <TableCell align="left">{row.expire_date}</TableCell>
                      <TableCell align="left">{ row.start_date !== '' ? (
                        <Button
                          color="secondary"
                          variant="contained"
                          size="small"
                          onClick={() => {
                            setCancelDIDOpen(true);
                            setSelectedRow(row);
                          }}
                        >
                        Cancel
                        </Button> ) : null }
                      </TableCell>
                    </TableRow>
                  );
                })
                ) :
                <TableRow role="checkbox">
                    <TableCell align="left"></TableCell>
                    <TableCell style={{verticalAlign: "middle", left: "40%", position: "sticky"}}>{loading ? (<CircularProgress size={40}/>) : "No data" }</TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left"></TableCell>
                </TableRow>
            }
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25,  { label: 'All', value: rows.length }]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage=""
          ActionsComponent={TablePaginationActions}
          labelDisplayedRows={({ from, to, count }) =>
            ''.concat(
            `${from}`,
            " to ",
            `${to === -1 ? count : to}`,
            ' from ',
            `${count !== -1 ? count : 'more then '.concat(`${to}`)}`
              )
          }
        />
    </div>
  );
}
export default DIDsTable;
